
// import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useUI } from '../context/UIContext';
// import { imgSrc } from '../lib/env';
// import { useCurrency } from '../context/CurrencyContext';
// // ─────────────────────────────────────────────────────────
// // Responsive hook
// // ─────────────────────────────────────────────────────────
// function useIsMobile(breakpoint = 768) {
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
//   );
//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth < breakpoint);
//     window.addEventListener('resize', handler);
//     return () => window.removeEventListener('resize', handler);
//   }, [breakpoint]);
//   return isMobile;
// }

// // ─────────────────────────────────────────────────────────
// // Storage helpers
// // ─────────────────────────────────────────────────────────
// const STORAGE_KEY = 'aurora_recently_viewed';

// export function trackProduct(product) {
//   if (!product?.id) return;
//   try {
//     const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
//     const filtered = stored.filter(p => p.id !== product.id);
//     const slim = {
//       id:       product.id,
//       name:     product.name,
//       brand:    product.brand,
//       price:    product.price,
//       was:      product.was,
//       img:      product.img,
//       category: product.category,
//       badge:    product.badge,
//       stock:    product.stock,
//     };
//     const updated = [slim, ...filtered].slice(0, 10);
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
//     window.dispatchEvent(new Event('aurora_rv_update'));
//   } catch { /* silently ignore */ }
// }

// export function getRecentlyViewed() {
//   try {
//     return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
//   } catch { return []; }
// }

// // ─────────────────────────────────────────────────────────
// // RecentlyViewed Section — shows last 2 products only
// // ─────────────────────────────────────────────────────────
// export default function RecentlyViewed() {
//   const [items, setItems] = useState([]);
//   const navigate = useNavigate();
//   const { openQV } = useUI();
//   const isMobile = useIsMobile();

//   const refresh = () => setItems(getRecentlyViewed().slice(0, 2));

//   useEffect(() => {
//     refresh();
//     window.addEventListener('aurora_rv_update', refresh);
//     window.addEventListener('storage', refresh);
//     return () => {
//       window.removeEventListener('aurora_rv_update', refresh);
//       window.removeEventListener('storage', refresh);
//     };
//   }, []);

//   if (items.length === 0) return null;

//   return (
//     <section style={{
//       padding: isMobile ? '48px 16px' : '72px 30px',
//       background: '#fff',
//       borderTop: '1px solid #ede9e3',
//     }}>
//       <div style={{ width: '100%', margin: '0 auto' }}>

//         {/* Header */}
//         <div style={{
//           display: 'flex',
//           alignItems: 'flex-end',
//           justifyContent: 'space-between',
//           marginBottom: isMobile ? 24 : 40,
//         }}>
//           <div>
//             <div style={{
//               fontSize: 10,
//               letterSpacing: '0.22em',
//               textTransform: 'uppercase',
//               color: 'var(--grey-mid)',
//               fontWeight: 500,
//               marginBottom: 10,
//               fontFamily: 'var(--font-body)',
//             }}>
//               Your Journey
//             </div>
//             <h2 style={{
//               fontFamily: 'var(--font-display)',
//               fontSize: 'clamp(24px,3.5vw,38px)',
//               fontWeight: 300,
//               color: 'var(--dark)',
//               letterSpacing: '-0.01em',
//               margin: 0,
//               lineHeight: 1.1,
//             }}>
//               Recently Viewed
//             </h2>
//           </div>

//           <button
//             onClick={() => navigate('/shop')}
//             style={{
//               background: 'none',
//               border: 'none',
//               cursor: 'pointer',
//               fontSize: 13,
//               letterSpacing: '0.18em',
//               textTransform: 'uppercase',
//               color: 'var(--dark)',
//               fontWeight: 600,
//               fontFamily: 'var(--font-body)',
//               textDecoration: 'underline',
//               textUnderlineOffset: 4,
//               paddingBottom: 2,
//               whiteSpace: 'nowrap',
//             }}>
//             Browse All
//           </button>
//         </div>

//         {/* 1 col on mobile, 2 col on desktop */}
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//           gap: isMobile ? 12 : 20,
//         }}>
//           {items.map(product => (
//             <RecentCard
//               key={product.id}
//               product={product}
//               isMobile={isMobile}
//               onClick={() => openQV(product)}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// // ─────────────────────────────────────────────────────────
// // Individual card
// // ─────────────────────────────────────────────────────────
// function RecentCard({ product, onClick, isMobile }) {
//   const [hovered, setHovered] = useState(false);
//   const { fmt } = useCurrency();          
//   const isSoldOut = Number(product.stock) === 0;

//   return (
//     <div
//       onClick={onClick}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         display: 'flex',
//         cursor: 'pointer',
//         border: '1px solid',
//         borderColor: hovered ? 'var(--dark)' : '#ede9e3',
//         transition: 'border-color 0.3s, box-shadow 0.3s',
//         boxShadow: hovered ? '0 8px 32px rgba(0,0,0,0.08)' : 'none',
//         background: '#fff',
//         overflow: 'hidden',
//         height: isMobile ? 140 : 'auto',
//       }}
//     >
//       {/* Image pane */}
//       <div style={{
//         width: isMobile ? 120 : 220,
//         height: isMobile ? 140 : 'auto',
//         flexShrink: 0,
//         background: '#f5f2ef',
//         position: 'relative',
//         overflow: 'hidden',
//       }}>
//         {imgSrc(product.img) ? (
//           <img
//             src={imgSrc(product.img)}
//             alt={product.name}
//             style={{
//               width: isMobile ? '100%' : '100%',
//               height: isMobile ? '100%' : '100%',
//               objectFit: 'cover',
//               display: 'block',
//               transform: hovered ? 'scale(1.05)' : 'scale(1)',
//               transition: 'transform 0.55s ease',
//               mixBlendMode: 'multiply',
//             }}
//           />
//         ) : (
//           <div style={{
//             width: '100%',
//             height: '100%',
//             minHeight: isMobile ? 120 : 160,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}>
//             <span style={{ fontSize: isMobile ? 28 : 36, opacity: 0.2 }}>👜</span>
//           </div>
//         )}

//         {product.badge && (
//           <div style={{
//             position: 'absolute',
//             top: 8,
//             left: 8,
//             background: 'var(--dark)',
//             color: '#fff',
//             fontSize: 7,
//             fontWeight: 700,
//             letterSpacing: '0.18em',
//             textTransform: 'uppercase',
//             padding: '3px 7px',
//             fontFamily: 'var(--font-body)',
//           }}>
//             {product.badge}
//           </div>
//         )}

//         {isSoldOut && (
//           <div style={{
//             position: 'absolute',
//             inset: 0,
//             background: 'rgba(255,255,255,0.6)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}>
//             <span style={{
//               fontSize: 8,
//               fontWeight: 700,
//               letterSpacing: '0.2em',
//               textTransform: 'uppercase',
//               color: 'var(--dark)',
//               background: '#fff',
//               padding: '4px 10px',
//               border: '1px solid var(--dark)',
//               fontFamily: 'var(--font-body)',
//             }}>
//               Sold Out
//             </span>
//           </div>
//         )}
//       </div>

//       {/* Info pane */}
//       <div style={{
//         flex: 1,
//         padding: isMobile ? '16px 14px' : '32px 28px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         gap: isMobile ? 8 : 14,
//         minWidth: 0,
//       }}>
//         <div>
//           <div style={{
//             fontSize: 9,
//             letterSpacing: '0.22em',
//             textTransform: 'uppercase',
//             color: 'var(--grey-mid)',
//             fontWeight: 600,
//             fontFamily: 'var(--font-body)',
//             marginBottom: 5,
//           }}>
//             {product.brand}
//           </div>

//           <div style={{
//             fontFamily: 'var(--font-display)',
//             fontSize: isMobile ? 'clamp(14px,3.8vw,18px)' : 'clamp(18px,2vw,26px)',
//             fontWeight: 300,
//             color: 'var(--dark)',
//             lineHeight: 1.3,
//             letterSpacing: '0.01em',
//             overflow: 'hidden',
//             display: '-webkit-box',
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: 'vertical',
//           }}>
//             {product.name}
//           </div>

//           {product.category && !isMobile && (
//             <div style={{
//               fontSize: 10,
//               color: 'var(--grey-mid)',
//               marginTop: 4,
//               fontFamily: 'var(--font-body)',
//               letterSpacing: '0.08em',
//             }}>
//               {product.category}
//             </div>
//           )}
//         </div>

//         {/* <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
//           <span style={{
//             fontFamily: 'var(--font-display)',
//             fontSize: isMobile ? 17 : 22,
//             fontWeight: 300,
//             color: 'var(--dark)',
//           }}>
//             ₹{Number(product.price).toLocaleString('en-IN')}
//           </span>
//           {product.was && (
//             <span style={{
//               fontSize: 11,
//               color: 'var(--grey-mid)',
//               textDecoration: 'line-through',
//               fontFamily: 'var(--font-body)',
//             }}>
//               ₹{Number(product.was).toLocaleString('en-IN')}
//             </span>
//           )}
//         </div> */}

//   {/* Price block — replace the ₹ spans */}
//   <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
//     <span style={{
//       fontFamily: 'var(--font-display)',
//       fontSize: isMobile ? 17 : 22,
//       fontWeight: 300,
//       color: 'var(--dark)',
//     }}>
//       {fmt(product.price)}          {/* ← was ₹{Number(product.price).toLocaleString('en-IN')} */}
//     </span>
//     {product.was && (
//       <span style={{
//         fontSize: 11,
//         color: 'var(--grey-mid)',
//         textDecoration: 'line-through',
//         fontFamily: 'var(--font-body)',
//       }}>
//         {fmt(product.was)}           {/* ← was ₹{Number(product.was).toLocaleString('en-IN')} */}
//       </span>
//     )}
//   </div>


//         <div style={{
//           fontSize: 9,
//           letterSpacing: '0.18em',
//           textTransform: 'uppercase',
//           fontWeight: 700,
//           color: hovered ? 'var(--gold)' : 'var(--dark)',
//           fontFamily: 'var(--font-body)',
//           transition: 'color 0.25s',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 5,
//         }}>
//           View Details
//           <span style={{
//             display: 'inline-block',
//             transform: hovered ? 'translateX(4px)' : 'translateX(0)',
//             transition: 'transform 0.25s',
//           }}>
//             →
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../context/UIContext';
import { imgSrc } from '../lib/env';
import { useCurrency } from '../context/CurrencyContext';

/* ─────────────────────────────────────────────
   Responsive hook
───────────────────────────────────────────── */
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
}

/* ─────────────────────────────────────────────
   Storage helpers
───────────────────────────────────────────── */
const STORAGE_KEY = 'aurora_recently_viewed';

export function trackProduct(product) {
  if (!product?.id) return;
  try {
    const stored   = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const filtered = stored.filter(p => p.id !== product.id);
    const slim = {
      id:       product.id,
      name:     product.name,
      brand:    product.brand,
      price:    product.price,
      was:      product.was,
      img:      product.img,
      category: product.category,
      badge:    product.badge,
      stock:    product.stock,
    };
    const updated = [slim, ...filtered].slice(0, 10);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event('aurora_rv_update'));
  } catch { /* silently ignore */ }
}

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
}

/* ─────────────────────────────────────────────
   RecentlyViewed Section
───────────────────────────────────────────── */
export default function RecentlyViewed() {
  const [items, setItems] = useState([]);
  const navigate          = useNavigate();
  const { openQV }        = useUI();
  const isMobile          = useIsMobile();

  const refresh = () => setItems(getRecentlyViewed().slice(0, 2));

  useEffect(() => {
    refresh();
    window.addEventListener('aurora_rv_update', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('aurora_rv_update', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="bg-white border-t border-[#ede9e3] py-12 md:py-[72px] px-4 md:px-[30px]">
      <div className="w-full">

        {/* Header */}
        <div className="flex items-end justify-between mb-6 md:mb-10">
          <div>
            <p className="aurora-eyebrow">Your Journey</p>
            <h2 className="font-display text-[clamp(24px,3.5vw,38px)] font-light text-[var(--dark)] tracking-[-0.01em] leading-[1.1] m-0">
              Recently Viewed
            </h2>
          </div>
          <button
            onClick={() => navigate('/shop')}
            className="aurora-link-btn"
          >
            Browse All
          </button>
        </div>

        {/* Grid — 1 col mobile, 2 col desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5">
          {items.map(product => (
            <RecentCard
              key={product.id}
              product={product}
              isMobile={isMobile}
              onClick={() => openQV(product)}
            />
          ))}
        </div>

      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   Individual card
───────────────────────────────────────────── */
function RecentCard({ product, onClick, isMobile }) {
  const [hovered, setHovered] = useState(false);
  const { fmt }               = useCurrency();
  const isSoldOut             = Number(product.stock) === 0;

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={[
        'flex cursor-pointer bg-white overflow-hidden border transition-all duration-300',
        isMobile ? 'h-[140px]' : 'h-auto',
        hovered
          ? 'border-[var(--dark)] shadow-[0_8px_32px_rgba(0,0,0,0.08)]'
          : 'border-[#ede9e3]',
      ].join(' ')}
    >
      {/* Image pane */}
      <div
        className={[
          'relative flex-shrink-0 overflow-hidden bg-[#f5f2ef]',
          isMobile ? 'w-[120px] h-[140px]' : 'w-[220px]',
        ].join(' ')}
      >
        {imgSrc(product.img) ? (
          <img
            src={imgSrc(product.img)}
            alt={product.name}
            className={[
              'w-full h-full object-cover block mix-blend-multiply',
              'transition-transform duration-[550ms] ease-in-out',
              hovered ? 'scale-[1.05]' : 'scale-100',
            ].join(' ')}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className={['opacity-20', isMobile ? 'text-[28px]' : 'text-[36px]'].join(' ')}>
              👜
            </span>
          </div>
        )}

        {/* Badge */}
        {product.badge && (
          <div className="absolute top-2 left-2 bg-[var(--dark)] text-white text-[7px] font-bold tracking-[0.18em] uppercase px-[7px] py-[3px] font-body">
            {product.badge}
          </div>
        )}

        {/* Sold out overlay */}
        {isSoldOut && (
          <div className="absolute inset-0 bg-white/60 flex items-center justify-center">
            <span className="text-[8px] font-bold tracking-[0.2em] uppercase text-[var(--dark)] bg-white px-[10px] py-1 border border-[var(--dark)] font-body">
              Sold Out
            </span>
          </div>
        )}
      </div>

      {/* Info pane */}
      <div
        className={[
          'flex-1 flex flex-col justify-between min-w-0',
          isMobile ? 'p-4 gap-2' : 'p-7 gap-3.5',
        ].join(' ')}
      >
        <div>
          {/* Brand */}
          <p className="text-[9px] tracking-[0.22em] uppercase text-[var(--grey-mid)] font-semibold font-body mb-[5px]">
            {product.brand}
          </p>

          {/* Name */}
          <p
            className={[
              'font-display font-light text-[var(--dark)] leading-[1.3] tracking-[0.01em] line-clamp-2',
              isMobile ? 'text-[clamp(14px,3.8vw,18px)]' : 'text-[clamp(18px,2vw,26px)]',
            ].join(' ')}
          >
            {product.name}
          </p>

          {/* Category — desktop only */}
          {product.category && !isMobile && (
            <p className="text-[10px] text-[var(--grey-mid)] mt-1 font-body tracking-[0.08em]">
              {product.category}
            </p>
          )}
        </div>

        {/* Price */}
        <div className="flex items-baseline gap-1.5 flex-wrap">
          <span
            className={[
              'font-display font-light text-[var(--dark)]',
              isMobile ? 'text-[17px]' : 'text-[22px]',
            ].join(' ')}
          >
            {fmt(product.price)}
          </span>
          {product.was && (
            <span className="text-[11px] text-[var(--grey-mid)] line-through font-body">
              {fmt(product.was)}
            </span>
          )}
        </div>

        {/* View Details */}
        <div
          className={[
            'text-[9px] tracking-[0.18em] uppercase font-bold font-body',
            'flex items-center gap-[5px] transition-colors duration-[250ms]',
            hovered ? 'text-[var(--gold)]' : 'text-[var(--dark)]',
          ].join(' ')}
        >
          View Details
          <span
            className={[
              'inline-block transition-transform duration-[250ms]',
              hovered ? 'translate-x-1' : 'translate-x-0',
            ].join(' ')}
          >
            →
          </span>
        </div>
      </div>
    </div>
  );
}